

































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Tag from '@/componentsV2/atoms/Tag/Tag.vue';

import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton,
    Tag
  }
})
export default class EnableEmail extends Vue {
  @Prop() onConfirm!: any;
  @Prop() nameEmail!: any;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  handleConfirm() {
    this.handleClose();
    this.onConfirm();
  }

  get title() {
    return this.$t(`${this.tPrefix}.enable.title`, {
      nameEmail: this.nameEmail
    });
  }

  get description() {
    return this.$t(`${this.tPrefix}.enable.description`, {
      nameEmail: this.nameEmail
    });
  }

  get tPrefix() {
    return 'emailAutomation.modals';
  }
}
